import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';
import ScheduleIcon from '@mui/icons-material/Schedule';
import Page from 'modules/Page';
import { i18n } from 'i18n';
import makePage from 'modules/makePage';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { usePage } from 'providers/page';
import * as projectsPageConstants from 'modules/project/ProjectsPage/constants';
import withNavigation from '../../withNavigation';
import * as constants from './constants';
import { QAQCAreaPageParams } from './constants';

const ActivePoursPage = lazyWithSuspense(() => import('./ActivePoursPage/ActivePoursPage'));
const BreakingSchedulesPage = lazyWithSuspense(() => import('./BreakingSchedulePage/BreakingSchedulePage'));
const QAQCAreaRootPage = makePage<QAQCAreaPageParams, []>({
  titleFn: () => i18n._('QAQC Area'),
  inheritParent: true,
});

interface QAQCAreaLocationState {
  parentPath?: string;
  parentTitle?: string;
}

const QAQCAreaRoot = () => {
  const { actions } = usePage();
  const location = useLocation();
  const state = location.state as QAQCAreaLocationState | undefined;

  React.useEffect(() => {
    actions.setParentPath(state?.parentPath ?? projectsPageConstants.ROUTE_PATH);
    actions.setParentTitle(state?.parentTitle ?? projectsPageConstants.TITLE);
  }, [actions, state?.parentPath, state?.parentTitle]);

  return React.createElement(QAQCAreaRootPage);
};

const page: Page<QAQCAreaPageParams> = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  component: withNavigation({
    Component: QAQCAreaRoot,
    defaultRoute: constants.ACTIVE_POURS_ROUTE_PATH,
    pageNavigation: [
      {
        title: i18n._(constants.ACTIVE_POURS_TITLE),
        iconComponent: FormatColorFillIcon,
        routeProps: {
          path: constants.ACTIVE_POURS_ROUTE_PATH,
        },
        Component: ActivePoursPage,
      },
      {
        title: i18n._(constants.BREAKING_SCHEDULES_TITLE),
        iconComponent: ScheduleIcon,
        routeProps: {
          path: constants.BREAKING_SCHEDULES_ROUTE_PATH,
        },
        Component: BreakingSchedulesPage,
      },
    ],
  }),
};

export default page;
